import React, { useContext } from 'react'
import CoinIcon from "../../Assets/Images/coin-icon1.png";
import { TokenContext } from "../../Context/TokenContext";
import largeCoinIcon from "../../Assets/Images/largeCoinIcon.svg"
import paymentSuccess from "../../Assets/Images/payment-successful.svg"
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import Disclaimer from '../TokenCheckoutPage/Disclaimer';
import { ArrowRightAlt } from '@mui/icons-material';
import { Button } from '@mui/material';

const TokenSuccessfulComponent = ({ clientId }) => {
    const location = useLocation()
    const navigate = useNavigate()
    const tokenCtx = useContext(TokenContext);
    const heading = "Tokens > Checkout";
    const { totalTokens, discountedAmount } = location.state || {};

    const calculatedAmount = (token) => {
  
      let calculatedAmount;
      if (token < 21) {
        calculatedAmount = token * 50
      } else if (token <= 100) {
        calculatedAmount = token * 45
      } else {
        calculatedAmount = token * 40
      }
      return `${calculatedAmount}`
    }

    console.log(discountedAmount)
    console.log(totalTokens)

    const handleClick = () => {
      navigate('/tokens')
    }

    const handleNavigate = () => {
      navigate(`/client/${clientId}`)
    }

    let tokenDigits = String(totalTokens).length
    console.log('tokenDigits', tokenDigits)

  return (
    <div className="payment-wrapper">
    <div className="payment-content">
      <div className="payment-checkout-container">
        <p className="payment-breadcrumb">{heading}</p>
        <div className="payment-layout">
          <div className="payment-main">
            <div className="icon-bg">
                <img src={largeCoinIcon} alt="CoinIcon" />
                <div className="coin-count" style={{ height: tokenDigits >= 3 ? '50px' : '40px', width: tokenDigits >= 3 ? '50px' : '40px'  }}>
                +{totalTokens}
                </div>
            </div>
            <div className="success-message"> 
                <div>
                <img src={paymentSuccess} alt="CoinIcon" />
                </div>
                <div className="sucesss-text-container">
                    <div className="title">You successfully paid ${discountedAmount}</div>
                    <div className="sub-title">You now have {tokenCtx.selectedToken} tokens in your wallet!</div>
                </div>
            </div>
            <div className="buy-more-token" onClick={handleClick}> 
                Buy more tokens
            </div>
            {/* <Button className='goto-asmt-cta' onClick={handleNavigate}>
              Go to Assessments <ArrowRightAlt />
            </Button> */}
          </div>

          <div className="payment-sidebar">
            <div className="payment-wallet-label">
              Wallet
            </div>
            <div className="payment-balance-box">
              <img
                src={CoinIcon}
                alt="Coin Icon"
                width={"22px"}
                height={"22px"}
              />
              <div className="payment-balance-text">You have {tokenCtx.selectedToken} tokens</div>
            </div>
            <div className="payment-pricing">
              <p className="payment-pricing-title">Pricing</p>
              <div className="payment-pricing-content">
                <div className="payment-pricing-item">
                  <p className="payment-item-title">Self - Assessment</p>
                  <div className="payment-token-count">
                    <img src={CoinIcon} alt="Coin Icon" className="payment-token-icon" />
                    <div className="payment-token-text">2 Tokens</div>
                  </div>
                </div>
                <div className="payment-pricing-item">
                  <p className="payment-item-title">360 Assessment</p>
                  <div className="payment-token-count">
                    <img src={CoinIcon} alt="Coin Icon" className="payment-token-icon" />
                    <div className="payment-token-text">4 Tokens</div>
                  </div>
                </div>
                <div className="payment-pricing-item">
                  <p className="payment-item-title">Group Report</p>
                  <div className="payment-token-count">
                    <img src={CoinIcon} alt="Coin Icon" className="payment-token-icon" />
                    <div className="payment-token-text">4 Tokens</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="payment-disclaimers">
              <Disclaimer />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default TokenSuccessfulComponent